import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { ErrorFragmentDoc } from '../../fragments/__generated__/Error.generated';
import { UserTranslationFragmentDoc } from '../../fragments/__generated__/UserTranslation.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateTranslationMutationVariables = Types.Exact<{
  input: Types.UpdateUserTranslationInput;
}>;


export type UpdateTranslationMutation = { updateUserTranslation: { errors: Array<{ field: string, messages: Array<string> }>, translation: { id: string, pk: number, originalText: string, currentText: string, entityType: string, entityId: number | null, fieldName: string, language: Types.LanguageEnum, status: Types.TranslationStatusEnum } | null } };

export type SetCurrencyMutationVariables = Types.Exact<{
  currency: Types.Scalars['String']['input'];
}>;


export type SetCurrencyMutation = { setCurrency: { currency: string | null, ok: boolean } };


export const UpdateTranslationDocument = gql`
    mutation UpdateTranslation($input: UpdateUserTranslationInput!) {
  updateUserTranslation(input: $input) {
    errors {
      ...Error
    }
    translation {
      ...UserTranslationFragment
    }
  }
}
    ${ErrorFragmentDoc}
${UserTranslationFragmentDoc}`;
export type UpdateTranslationMutationFn = Apollo.MutationFunction<UpdateTranslationMutation, UpdateTranslationMutationVariables>;

/**
 * __useUpdateTranslationMutation__
 *
 * To run a mutation, you first call `useUpdateTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTranslationMutation, { data, loading, error }] = useUpdateTranslationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTranslationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTranslationMutation, UpdateTranslationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTranslationMutation, UpdateTranslationMutationVariables>(UpdateTranslationDocument, options);
      }
export type UpdateTranslationMutationHookResult = ReturnType<typeof useUpdateTranslationMutation>;
export type UpdateTranslationMutationResult = Apollo.MutationResult<UpdateTranslationMutation>;
export type UpdateTranslationMutationOptions = Apollo.BaseMutationOptions<UpdateTranslationMutation, UpdateTranslationMutationVariables>;
export const SetCurrencyDocument = gql`
    mutation SetCurrency($currency: String!) {
  setCurrency(currency: $currency) {
    currency
    ok
  }
}
    `;
export type SetCurrencyMutationFn = Apollo.MutationFunction<SetCurrencyMutation, SetCurrencyMutationVariables>;

/**
 * __useSetCurrencyMutation__
 *
 * To run a mutation, you first call `useSetCurrencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCurrencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCurrencyMutation, { data, loading, error }] = useSetCurrencyMutation({
 *   variables: {
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useSetCurrencyMutation(baseOptions?: Apollo.MutationHookOptions<SetCurrencyMutation, SetCurrencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCurrencyMutation, SetCurrencyMutationVariables>(SetCurrencyDocument, options);
      }
export type SetCurrencyMutationHookResult = ReturnType<typeof useSetCurrencyMutation>;
export type SetCurrencyMutationResult = Apollo.MutationResult<SetCurrencyMutation>;
export type SetCurrencyMutationOptions = Apollo.BaseMutationOptions<SetCurrencyMutation, SetCurrencyMutationVariables>;